var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',_vm._g(_vm._b({staticClass:"mt-0 v-input--dense v-text-field v-text-field--filled v-text-field--rounded",attrs:{"dense":"","inset":""}},'v-switch',{ ..._vm.$attrs, ..._vm.$props },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }